export const IS_TESTNET: boolean = false
